export const sexemus = [
  { text:"男", value:0},
  { text:"女", value:1}
];

export const messageTypeEmus = [
  { text:"短信内容默认申请审核通知消息", value:0},
  { text:"语音文件通过审核的通知消息", value:1},
  { text:"新客户通知", value:60},
  { text:"充值通知", value:98},
  { text:"余额不足通知", value:99},
  { text:"系统通知", value:100},

];

export const gradeEmus = [
  { text:"A类(较强)", value:21 , entext: "A"},
  { text:"B类(一般)", value:22, entext: "B"},
  { text:"C类(很少)", value:23, entext: "C"},
  { text:"D类(需筛选)", value:24, entext: "D"},
  { text:"E类(需再次跟进)", value:25, entext: "E"},
  { text:"F类", value:26, entext: "F"},
  { text:"G类", value:27, entext: "G"},
  { text:"H类", value:28, entext: "H"},
  { text:"I类", value:29, entext: "I"},

];

export const llmGradeEmus = [
  { text:"高", value:"高" , entext: "High"},
  { text:"中", value:"中", entext: "Middle"},
  { text:"低", value:"低", entext: "Low"},
  { text:"无", value:"无", entext: "None"},
];


export const weekEmus = [
  { text:"星期一", value:1 , entext: "Monday"},
  { text:"星期二", value:2 , entext: "Tuesday"},
  { text:"星期三", value:3 , entext: "Wednesday"},
  { text:"星期四", value:4 , entext: "Thursday"},
  { text:"星期五", value:5 , entext: "Friday"},
  { text:"星期六", value:6 , entext: "Saturday"},
  { text:"星期日", value:7 , entext: "Sunday"},
];


export const robotSpeedDataEnums = [
  {value:1001,text:"极速模式（超快）", entext: "Extreme speed mode (ultra fast)"},
  {value:1002,text:"快速模式（快）", entext: "Quick mode (fast)"},
  {value:1003,text:"普通模式（正常）", entext: "Normal mode (normal)"},
  {value:1004,text:"慢速模式（慢）", entext: "Slow mode (slow)"},
  {value:1005,text:"极慢模式（极慢）", entext: "Extremely slow mode (extremely slow)"},
  {value:1006,text:"变态慢模式（变态慢）", entext: "Abnormal slow mode (abnormal slow)"},
  {value:1007,text:"老年人模式一（正常）", entext: "Elderly Mode 1 (normal)"},
  {value:1008,text:"老年人模式二（慢）", entext: "Elderly Mode 2 (slow)"},
  {value:1009,text:"老年人模式三（极慢）", entext: "Elderly Mode 3 (extremely slow)"},
  {value:9999,text:"自定义", entext: "Ecustomize"},
];

//跟进阶段类型   100 新入库  200 AI初访   300人工初访    400意向    500报价   600成交
export const followStageEnums = [
  { text:"新入库", value:100},
  { text:"AI初访", value:200},
  { text:"跟进中", value:300},
  { text:"有意向", value:400},
  { text:"待洽谈", value:500},
  { text:"已成交", value:600},
];

export const orderStatus2Emus = [
  { text:"补充资料", value:1},
  { text:"审批中", value:2},
  { text:"审批完成", value:3},
  { text:"抵押", value:4},
  { text:"放款", value:5},
];

export const jumpTypeEmus = [
  { text:"挂机", value:0, entext: "Hangup"},
  { text:"下一主动流程", value:2, entext: "Next proactive process"},
  { text:"指定主动流程", value:3, entext: "Specify proactive processes"},
  { text:"转人工", value:4, entext: "Transfer to manual labor"},
];

export const knowJumpTypeEmus = [
  { text:"挂机", value:0, entext: "Hangup"},
  { text:"等待用户应答", value:1, entext: "Waiting for user response"},
  { text:"下一主动流程", value:2, entext: "Next proactive process"},
  { text:"指定主动流程", value:3, entext: "Specify proactive processes"},
  { text:"转人工", value:4, entext: "Transfer to manual labor"},
];


export const followRemindEmus = [
  { text:"跟进", value:1},
  { text:"提醒", value:0},
];

//跟进类型   201 AI呼出  301 电话拜访  302 邀约上门   310 当面拜访    320 网络拜访   330 短信拜访
export const followTypeEmus = [
  { text:"电话联系", value:301},
  { text:"当面交流", value:310},
  { text:"短信联系", value:330},
  { text:"微信/QQ", value:320},
  { text:"系统通知 - AI拜访", value:201},
  { text:"系统通知 - 事件", value:500},
  { text:"系统通知 - 提醒", value:501},
];

export const loanTypeEmus = [
  { text:"商贷", value:1},
  { text:"公积金贷", value:2},
  { text:"组合贷", value:3},
];

export const knowTypeEmus = [
  { text:"一般问题", value:10001, entext: "General question"},
  { text:"业务问题", value:20001, entext: "Business question"},
];


export const strategyAllocationEmus = [
  { text:"分配给自己", value:0},
  { text:"均分给下级", value:1},
  { text:"按数量分配", value:2},
];


export const repaymentTypeEmus = [
  { text:"等额本息", value:1},
  { text:"等额本金", value:2},
  { text:"先息后本", value:3},
];

export const loanYearsEmus = [
  { text:"5年"},
  { text:"10年"},
  { text:"15年"},
  { text:"20年"},
  { text:"30年"},
];

export const maritalStatusEmus = [
  { text:"单身", value:"0"},
  { text:"已婚", value:"1"},
  { text:"离异", value:"2"},
];

export const buyerDataEmus = [
  { text:"身份证", value:0},
  { text:"户口本", value:1},
  { text:"婚姻证明", value:2},
  { text:"收入证明", value:3},
  { text:"银行流水", value:4},
  { text:"卡", value:5},
  { text:"征信", value:6},
  { text:"公积金缴存证明", value:7},
  { text:"公积金缴存明细", value:8},
];

export const intermediaryDataEmus = [
  { text:"网签/经济服务合同", value:0},
];

export const sellerDataEmus = [
  { text:"身份证", value:0},
  { text:"户口本", value:1},
  { text:"婚姻证明", value:2},
  { text:"卡", value:3},
  { text:"产权证", value:4},
  { text:"摘要/查档", value:5},
];

export const intermediaryTypeEnums = [
  { text:"中介", value:1},
  { text:"楼盘", value:2}
];

export const ruleTypeEnums = [
  { text:"命中所有问题", value:5000, entext: "Hit all questions"},
  { text:"命中业务问题", value:5001, entext: "Hit business questions"},
  { text:"肯定次数", value:5002, entext: "affirms"},
  { text:"拒绝次数", value:5003, entext: "refuses"},
  { text:"客户讲话次数", value:5004, entext: "talk"},
  { text:"通话时长", value:5005, entext: "call duration"},
  { text:"客户通话内容", value:5006, entext: "call content"},
  { text:"走完主流程", value:5007, entext: "Complete the main process"},
  { text:"通话状态", value:5008, entext: "Call status"},
  { text:"客户说最后一句", value:5009, entext: "The customer said the last sentence"},
  { text:"对话轮次", value:5010, entext: "talk round"},
  //{ text:"谁主动挂断", value:5050},
];

export const symbolTypeEnums = [
  { text:">=", value:1},
  { text:"<=", value:2},
];

export const symbolContentTypeEnums = [
  { text:"包含1个以上", value:1, entext: "Including more than 1"},
  { text:"包含2个以上", value:3, entext: "Including more than 2"},
  { text:"包含3个以上", value:4, entext: "Including more than 3"},
  { text:"包含4个以上", value:5, entext: "Including more than 4"},
  { text:"包含5个以上", value:6, entext: "Including more than 5"},
  { text:"包含6个以上", value:7, entext: "Including more than 6"},
  { text:"包含7个以上", value:8, entext: "Including more than 7"},
  { text:"包含8个以上", value:9, entext: "Including more than 8"},
  { text:"包含9个以上", value:10, entext: "Including more than 9"},
  { text:"包含10个以上", value:11, entext: "Including more than 10"},
  { text:"包含全部", value:2, entext: "Include all"},
];

export const hangupTypeEnums = [
  { text:"天盾拦截", value:72, entext: "Tiandun interception"},
];

export const defaultRuleEnums = [
  { text:"默认规则一（严格）", value:1, entext: "Default Rule One (Strict)"},
  { text:"默认规则二（宽松）", value:2, entext: "Default Rule 2 (Loose)"},
];


export const smsChannelEnums = [
  { text: "企业信使", value: 1, entext: "Enterprise Messenger" },
  { text: "企业信使2", value: 18, entext: "Enterprise Messenger 2" },
  { text: "短信宝", value: 2, entext: "SMS Bao" },
  { text: "互亿无线", value: 3, entext: "IHuyi" },
  { text: "得伯乐短信服务器", value: 4, entext: "Debole SMS" },
  { text: "盛视无限", value: 5, entext: "SSWX" },
  { text: "秒嘀科技", value: 6, entext: "Miaodi" },
  { text: "瀚达云端", value: 7, entext: "Handayan Cloud" },
  { text: "阿里短信服务", value: 10, entext: "Alibaba SMS" },
  { text: "讯秒云短信服务", value: 11, entext: "Xunmiao SMS" },
  { text: "简讯短信服务", value: 12, entext: "Jianxun SMS" },
  { text: "云片短信服务", value: 13, entext: "Yunpian SMS" },
  { text: "和闰", value: 14, entext: "Herun" },
  { text: "中国移动MAS平台", value: 15, entext: "China Mobile MAS" },
  { text: "亿展达短信服务", value: 16, entext: "Yizhanda SMS" },
  { text: "云联通讯", value: 17, entext: "Yunlian" },
  { text: "量子数据", value: 19, entext: "Quantum Data" },
  { text: "赛邮·云通信", value: 20, entext: "Submail" },
  { text: "短信服务JZ", value: 97, entext: "SMS JZ" },
  { text: "未知名-全球短信服务", value: 98, entext: "Unknown Global SMS" },
  { text: "其它短信服务", value: 99, entext: "Other SMS" },
];

export const taskStatusEnums = [
  { text:"未开始", value:1},
  { text:"排队中", value:4},
  { text:"进行中", value:2},
  { text:"用户暂停", value:0},
  { text:"系统挂起", value:12},
  { text:"欠费暂停", value:13},
  { text:"今日暂停", value:14},
  { text:"已完成", value:10},
];


export const weekEnums = [
  { text:"周一", value:1, entext:"Monday"},
  { text:"周二", value:2, entext:"Tuesday"},
  { text:"周三", value:3, entext:"Wednesday"},
  { text:"周四", value:4, entext:"Thursday"},
  { text:"周五", value:5, entext:"Friday"},
  { text:"周六", value:6, entext:"Saturday"},
  { text:"周日", value:7, entext:"Sunday"},
];


export const tpPhoneGradeEmus = [
  { text:"A类(较强)", value:21, entext: "A"},
  { text:"B类(一般)", value:22, entext: "B"},
  { text:"C类(很少)", value:23, entext: "C"},
  { text:"D类(需筛选)", value:24, entext: "D"},
  { text:"E类(需再次跟进)", value:25, entext: "E"},
  { text:"F类", value:26, entext: "F"},
  { text:"G类", value:27, entext: "G"},
  { text:"H类", value:28, entext: "H"},
  { text:"I类", value:29, entext: "I"},
  { text:"关机", value:62, entext: "shutdown"},
  { text:"空号", value:63, entext: "vacant number"},
  { text:"停机", value:64, entext: "halt"},
  { text:"拒接", value:65, entext: "refuse"},
  { text:"无法接通", value:66, entext: "unavailable"},
  { text:"占线", value:67, entext: "busy"},
  { text:"无人接听", value:68, entext: "nobody"},
  { text:"正在通话中", value:69, entext: "during"},
  { text:"助理拦截", value:70, entext: "reminder"},
  { text:"黑名单", value:71, entext: "blacklist"},
  { text:"呼入限制", value:79, entext: "loss"},
  { text:"R-未知", value:90, entext: "R-unknow"},
];


export const tpDaXXXEmus = [
  { text:"关机", value:62, entext: "shutdown"},
  { text:"空号", value:63, entext: "vacant number"},
  { text:"停机", value:64, entext: "halt"},
  { text:"拒接", value:65, entext: "refuse"},
  { text:"无法接通", value:66, entext: "unavailable"},
  { text:"占线", value:67, entext: "busy"},
  { text:"无人接听", value:68, entext: "nobody"},
  { text:"正在通话中", value:69, entext: "during"},
  { text:"助理拦截", value:70, entext: "reminder"},
  { text:"黑名单", value:71, entext: "blacklist"},
  { text:"呼入限制", value:79, entext: "loss"},
  { text:"R-未知", value:90, entext: "R-unknow"},
];


export const importFilterPhoneStrategyEnums = [
  { text:"未呼客户号码去重", value:1, entext: "Number deduplication"},
  { text:"未呼客户号码去重+过滤掉座机号码", value:2, entext: "Number deduplication + Filter out the landline number"},
  { text:"未呼客户号码去重+按条件去除号码", value:3, entext: "Number deduplication + Remove numbers by condition"},
  { text:"未呼客户号码去重+导入的是加密号码", value:4, entext: "Number deduplication + The imported code is an encrypted number"},
];


export const classFieldEnums = [
  { text:"客户姓名", value:1},
  { text:"客户号码", value:2},
  { text:"拨打时间", value:3},
  { text:"等级状态", value:4},
  { text:"自定义文字", value:5},
  { text:"账号即将过期提醒", value:6},
  { text:"任务拨打完成提醒", value:7},
  { text:"余额不足提醒", value:8},
  { text:"任务名称", value:9},
];



// WEBPACK FOOTER //
// ./src/utils/enums.js